<header>
  <div class="container-fluid bg-dark bg-opacity-75">
    <div class="row">
      <div class="col-auto d-flex align-items-center justify-content-center">

        <a href="/" class="d-flex flex-row align-items-center text-white text-decoration-none">
          <img height="120" class="p-2 px-lg-4" alt="Logo" src="/images/logo.png">
          <h2>Lakeshore Landing</h2>
        </a>

      </div>
      <div class="col d-flex align-items-center justify-content-start">

        <!-- Desktop -->
        <mat-toolbar class="toolbar">

          <span class="toolbar-spacer"></span>

          <a mat-button [routerLink]="['/home']" routerLinkActive="active">Home</a>

          <a mat-button class="" [routerLink]="['/contact']" routerLinkActive="active">Contact</a>

          <span class="toolbar-spacer"></span>

        </mat-toolbar>

      </div>
      <div class="col-auto d-flex align-items-center">

        <button mat-icon-button [matMenuTriggerFor]="themeMenu" class="text-white" aria-label="Change theme">
          <mat-icon>{{ themeIcon() }}</mat-icon>
        </button>
        <mat-menu #themeMenu="matMenu">
          <button mat-menu-item (click)="setTheme('light')">
            <mat-icon>light_mode</mat-icon>
            <span>Light</span>
          </button>
          <button mat-menu-item (click)="setTheme('dark')">
            <mat-icon>dark_mode</mat-icon>
            <span>Dark</span>
          </button>
          <button mat-menu-item (click)="setTheme('system')">
            <mat-icon>brightness_auto</mat-icon>
            <span>System</span>
          </button>
        </mat-menu>

      </div>
    </div>
  </div>
</header>
